// A form may recover authentication in place without unmounting its unsaved inputs.
module.exports = error => !!(error.response && error.response.status === 401 &&
  !(error.config && error.config.handleAuthenticationLocally === true));
